<template>
  <Dialog
    v-model:visible="isVisible"
    header="Waive payment"
    modal
    :style="{ width: '28rem' }"
    :closable="!isLoading"
  >
    <p class="text-gray-700">Are you sure you want to waive this payment?</p>

    <Divider />

    <div class="flex items-center gap-2">
      <Checkbox v-model="applyToAll" input-id="applyToAllWaive" binary />
      <label for="applyToAllWaive" class="font-medium cursor-pointer">
        Apply to all payments in plan
      </label>
    </div>

    <template #footer>
      <div class="flex justify-end gap-4">
        <Button
          label="Go back"
          text
          severity="secondary"
          :disabled="isLoading"
          @click="emit('go-back')"
        />
        <Button
          label="Waive Payment"
          :loading="isLoading"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import Divider from "primevue/divider";

interface Props {
  isLoading?: boolean;
}

withDefaults(defineProps<Props>(), { isLoading: false });

const emit = defineEmits<{
  "go-back": [];
  confirm: [];
}>();

const isVisible = defineModel<boolean>("visible", { required: true });
const applyToAll = defineModel<boolean>("applyToAll");
</script>
